/// @flow
import React, { PureComponent } from 'react';
import { dynamicClassName } from 'utils/dynamicClassName';

type Props = {
  id: string,
  label: string,
  isDark?: boolean,
  onChange?: (checked: boolean) => void,
  children?: ?React$Node[],
  className?: string,
};

class CheckboxInput extends PureComponent<Props> {
  props: Props;

  static defaultProps = {
    id: 'checkboxinput123',
    children: null,
    label:
      'J’accepte les emails de la Ligue Franche comté de rugby à propos des nouveautés et promotions de la Ligue. ' +
      ' Je peux me désinscrire à tout moment en utilisant le lien pour me désabonner au pied de la newsletter.',
    onChange: () => {},
    isDark: false,
  };

  handleCheckboxCliked = (e: any) => {
    const { onChange } = this.props;

    if (onChange) onChange(e.target.checked);
  };
  render() {
    const { id, isDark, className, children, label: propsLabel } = this.props;
    const classNames = dynamicClassName('checkbox col col-lg-4');
    const label = children
      ? (
        <label htmlFor={id}>
          {children}
        </label>
      )
      : <label htmlFor={id} dangerouslySetInnerHTML={{ __html: propsLabel }} />;

    isDark && classNames.add('is-dark');

    return (
      <div className={className ? className : classNames.build()}>
        <input type="checkbox" id={id} onClick={this.handleCheckboxCliked} />
        {label}
      </div>
    );
  }
}

export default CheckboxInput;
